<template>
  <div class="slim-mainpanel">
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Configuracões</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Configuracões Administrativas</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ mainTitle }}
          </li>
        </ol>
        <h6 class="slim-pagetitle">Listagem de {{ modelTitle }}</h6>
      </div>

      <div class="card card-table">
        <div class="card-header">
          <div class="report-summary-header mg-t-0 mg-b-0 mg-l-100">
            <div>
              <h4 class="tx-inverse mg-b-3">Listagem de {{ modelTitle }}</h4>
              <p class="mg-b-0">
                Foram encontrados {{ data.length }} registros de
                <b>{{ modelTitle }}</b> cadastradas
              </p>
            </div>
            <div>
              <router-link
                :to="{ name: 'accounts-form', params: { action: 'create' } }"
                class="btn btn-primary"
              >
                <i class="icon ion-plus tx-22"></i> ADICIONAR
              </router-link>
            </div>
          </div>
        </div>

        <v-client-table :columns="columns" :data="data" :options="options">
          <template slot="enabled" slot-scope="props">
            <div class="enabled">
              <span v-if="props.row.enabled" class="badge badge-success"
                >SIM</span
              >
              <span v-if="!props.row.enabled" class="badge badge-danger"
                >NÃO</span
              >
            </div>
          </template>
          <template slot="principal" slot-scope="props">
            <div class="enabled">
              <span v-if="!props.row.principal" class="badge badge-indigo"
                >SIM</span
              >
              <span v-if="props.row.principal" class="badge badge-teal"
                >NÃO</span
              >
            </div>
          </template>
          <template slot="actions" slot-scope="props">
            <router-link
              :to="{
                name: 'accounts-form',
                params: { action: 'update', id: props.row.id },
              }"
              class="btn btn-primary btn-icon rounded-circle mg-r-5"
            >
              <div>
                <i class="icon ion-edit"></i>
              </div>
            </router-link>
            <a
              href="#"
              @click="deleteModel(props.row)"
              class="btn btn-danger btn-icon rounded-circle"
            >
              <div>
                <i class="icon ion-trash-a"></i>
              </div>
            </a>
          </template>
        </v-client-table>
      </div>
      <!-- card -->
    </div>
  </div>
</template>

<script>
import * as constants from "@/consts.js";
import config from "@/config.js";
import Axios from "axios";
import { TheMask } from "vue-the-mask";
import DatePicker from "vue2-datepicker";
import UtilsService from "@/services/UtilsService.js";

export default {
  name: "configuration-accounts-list",

  data() {
    return {
      modelTitle: "Unidades da Empresa",
      mainTitle: "Unidades da Empresa",
      columns: [
        "enabled",
        "principal",
        "name",
        "federalID",
        "municipalRegistration",
        "stateRegistration",
        "telephone1",
        "city",
        "federalUnity",
        "actions",
      ],
      data: new Array(),
      options: {
        listColumns: {
          enabled: [
            {
              id: true,
              text: "Sim",
            },
            {
              id: false,
              text: "Não",
            },
            {
              id: "",
              text: "Todos",
            },
          ],
          principal: [
            {
              id: false,
              text: "Sim",
            },
            {
              id: true,
              text: "Não",
            },
            {
              id: "",
              text: "Todos",
            },
          ],
        },
        headings: {
          enabled: "Habilitado",
          name: "Nome",
          federalID: "CNPJ",
          principal: "Filial",
          municipalRegistration: "Inscrição Municipal",
          stateRegistration: "Inscrição Estadual",
          telephone1: "Telefone",
          federalUnity: "UF",
          city: "Cidade",
          action: "Ações",
        },
        sortable: [
          "enabled",
          "name",
          "federalID",
          "municipalRegistration",
          "stateRegistration",
          "telephone1",
          "city",
          "federalUnity",
          "principal",
        ],
        filterable: [
          "enabled",
          "name",
          "telephone1",
          "federalID",
          "municipalRegistration",
          "city",
          "stateRegistration",
          "principal",
          "federalUnity",
        ],

        texts: {
          count:
            "Mostrando página {from} de {to} páginas que contém um total de {count}  resultados.|{count} resultados.|Um resultado",
          filter: "Filtrar resultados:",
          filterPlaceholder: "Buscar",
          limit: "Exibir: ",
          page: "Página:",
          noResults: "Nenhum resultado foi encontrado.",
          filterBy: "Filtrar por {column}",
          loading: "Carregando...",
          defaultOption: "{column}",
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        filterByColumn: true,
        highlightMatches: true,
        footerHeadings: false,
        pagination: {
          edge: true,
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100, 500],
      },
    };
  },
  methods: {
    loadList() {
      Axios.get(`${config.env.API_DEFAULT.host}/accounts`)
        .then((response) => {
          this.data = response.data._embedded.accounts;
        })
        .catch((error) => {
          this.$swal(
            this.modelTitle,
            " Não foi possível carregar listagem.",
            "error"
          );
        });
    },
    edit() {
      this.$router.push(`/${response.data.id}`);
    },
    deleteModel(row) {
      this.$swal({
        title: "Você tem certeza?",
        text: `Se você excluir a ${this.modelTitle}, não será possível recuperá-la para uso posterior.`,
        icon: "warning",
        buttons: ["Não", "Sim"],
        dangerMode: true,
      }).then((willContinue) => {
        if (willContinue) {
          Axios.delete(`${config.env.API_DEFAULT.host}/accounts/${row.id}`)
            .then((response) => {
              this.$swal(
                this.modelTitle,
                `${this.modelTitle} foi removida c/ sucesso!`,
                "success"
              );
              this.loadList();
            })
            .catch((error) => {
              if (error.response.status === 409)
                this.$swal(
                  this.modelTitle,
                  `Não foi possível excluir a ${this.modelTitle}, porque ela já está em uso por algum lançamento financeiro.`,
                  "error"
                );
              else this.$swal(this.modelTitle, error.message, "error");
            });
        }
      });
    },
  },
  mounted() {
    this.loadList();
  },
};
</script>
